"use strict";
var alert_component_1 = require('./alert/alert.component');
exports.AlertComponent = alert_component_1.AlertComponent;
var alert_module_1 = require('./alert/alert.module');
exports.AlertModule = alert_module_1.AlertModule;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/ng2-bootstrap/components/alert.js
// module id = ../../../../ng2-bootstrap/components/alert.js
// module chunks = 3